import { useEffect, useState } from "react";
import {
  getCachedRowsPerPageSync,
  getRowsPerPageSetting,
  setRowsPerPageSetting,
} from "utils/api/uiSettingsApi";

// Drop-in replacement for `useState<number>` that hydrates from
// /UISettings/grids/rowsPerPageSetting on mount and POSTs on every change.
// After the first GET in the session, the sync cache lets every subsequent
// tab-activation mount start at the correct value immediately — no flicker
// through the fallback.
export function usePersistedRowsPerPage(
  initialValue: number
): [number, (next: number) => void] {
  const [pageSize, setPageSizeState] = useState<number>(
    () => getCachedRowsPerPageSync() ?? initialValue
  );
  useEffect(() => {
    let mounted = true;
    getRowsPerPageSetting().then((value) => {
      if (mounted) setPageSizeState(value);
    });
    return () => {
      mounted = false;
    };
  }, []);
  const setPageSize = (next: number) => {
    setPageSizeState(next);
    // Fire-and-forget; backend persists, local state is the source of truth.
    void setRowsPerPageSetting(next);
  };
  return [pageSize, setPageSize];
}
